module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="lotteryDg" style="width:1px;height:1px;position: absolute;left:-9999px;top:0;"></div>';
}
return __p;
};
